/* eslint jsx-a11y/label-has-for: 0 */
import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import styles from './styles.scss'

const FormFieldLayout = ({
  fieldName,
  labelText,
  fieldElement,
  description,
  error,
  extraClasses,
}) => {
  const errorElement = error.status ? <p className={styles.error}>{error.message}</p> : null

  return (
    <div
      className={classNames(
        styles.element_group,
        extraClasses,
        { [styles.hasError]: error.status },
      )}
    >
      <label className={styles.label} htmlFor={fieldName}>{labelText}</label>
      {fieldElement}
      {errorElement}
      {description && <p className={styles.description}>{description}</p>}
    </div>
  )
}

const defaultInput = (
  <input
    type="text"
    className="form-input"
    id="genericInput"
    placeholder="Just a label"
    maxLength="50"
  />
)

FormFieldLayout.defaultProps = {
  fieldName: 'genericInput',
  labelText: 'Input label',
  fieldElement: defaultInput,
  description: '',
  error: { status: false, message: '' },
  extraClasses: '',
}

FormFieldLayout.propTypes = {
  fieldName: PropTypes.string,
  labelText: PropTypes.string,
  fieldElement: PropTypes.any,
  extraClasses: PropTypes.string,
  description: PropTypes.string,
  error: PropTypes.shape({
    status: PropTypes.bool,
    message: PropTypes.string,
  }),
}

export default FormFieldLayout



// WEBPACK FOOTER //
// ./layouts/FormFieldLayout/index.jsx